import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  @Input() logoClasses = '';
  constructor(private router: Router) {}

  ngOnInit(): void {}

  goHome() {
    this.router.navigateByUrl('homepage');
  }
}
